// https://github.com/DavidBruant/Map-Set.prototype.toJSON
var $def  = require('./$.def');

$def($def.P, 'Map', {toJSON: require('./$.collection-to-json')('Map')});


/** WEBPACK FOOTER **
 ** ./~/react-native-winjs/~/core-js/library/modules/es7.map.to-json.js
 **/